import { render } from "./ShowMorph.vue?vue&type=template&id=3fba78cc&scoped=true&ts=true"
import script from "./ShowMorph.vue?vue&type=script&lang=ts"
export * from "./ShowMorph.vue?vue&type=script&lang=ts"

import "./ShowMorph.vue?vue&type=style&index=0&id=3fba78cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fba78cc"]])

export default __exports__